export const stringToMask = (value, pattern) => {
  let index = 0
  const stringValue = value.toString()
  return pattern.replace(/9/g, () => stringValue[index++])
}
